module.exports = __webpack_public_path__ + "static/assets/0051f19c3035bdaca5117f973f571af0.svg";